<template>
  <div class="slider" >
    <carousel :items="1" :rewind="true" :autoplay="true" :nav="false">
      <template slot="prev"><div class="button-slider pp-icon-arrow button-prev"></div></template>
      <div v-for="(banner, index) in sliders" :key="index">
        <a :href="banner['href']" @click="onClickBanner" :target="banner['target']">
          <img class="slider-item" :src="banner['src']" :title="banner.title" :alt="banner.title">
        </a>
      </div>
      <template slot="next"><div class="button-slider pp-icon-arrow button-next"></div></template>
    </carousel>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  name: "HeaderSlider",
  props: ['sliders'],
  methods: {
    onClickBanner: function(event){
      const href = event.target.parentNode.getAttribute("href");
      if(!href) {
        event.preventDefault();
        return false;
      }
      const regExp = new RegExp(/#product-/);
      if(regExp.test(href)) {
        event.preventDefault();
        const productCode = href.split('#product-')[1];
        document.getElementById(productCode).click();
      }
      return true;
    },
    isProductLink: function (){

    }
  },
  components: {
    carousel: carousel
  }
}
</script>

<style scoped>

</style>